/*
Created By Sushma Muppala 2023
*/

import ComplicationSelector from "@ls/grouping-complication-selector";
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import SelectionState from "state/selections/SelectionState";
import ComplicationComponent from "./Scan2Complication";
import { selectDefinitions } from "state/scan2/selectors";
import { setDefinition } from "state/scan2/actions";
import Scan2Definition from "state/scan2/Scan2Definition";

const Scan2Selector = (props) => {
  const dispatch = useDispatch();
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const setDefinitionCallback = useCallback(
    (idx, definition) => dispatch(setDefinition(idx, definition)),
    [dispatch]
  );
  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinitionCallback}
      getDefaultDefinition={Scan2Definition.getDefault}
      ComplicationComponent={ComplicationComponent}
      btnTitle={"VaR"}
      addMoreText={"VaR (% Return)"}
    />
  );
};
export default Scan2Selector;
